export default __webpack_public_path__ + "static/media/phone.d4cd7ab7.svg";